import * as React from 'react';

import { INewbuildingMapPin } from '../../types/map';
import { MapModal } from '../MapModal';
import { NewbuildingsMap, TNewbuildingsMapPlatform } from '../NewbuildingsMap';

export interface INewbuildingsMapModalProps {
  apiKey: string;
  pins: INewbuildingMapPin[];
  platform?: TNewbuildingsMapPlatform;
  onClose(): void;
  onPinClick(pin: INewbuildingMapPin): void;
}

export function NewbuildingsMapModal({
  apiKey,
  pins,
  platform,
  onClose,
  onPinClick,
}: INewbuildingsMapModalProps): React.JSX.Element {
  return (
    <MapModal testId="newbuildings-map-modal" onClose={onClose}>
      <NewbuildingsMap apiKey={apiKey} pins={pins} platform={platform} onPinClick={onPinClick} />
    </MapModal>
  );
}
